import React from "react";
import ResponsiveDrawer from "../../components/drawer/Drawer";
import { useTranslation } from "react-i18next";
import globalStyles from "../../style/global.js";
import useStyles from "./homeStyle";
import { Box, Typography } from "@mui/material";
import CardsNumber from "../../components/cardNumbers/CardsNumber";
import AreaChartView from "../../components/areaChart/AreaChart";
import TimeRemaining from "../../components/timeRemaining/TimeRemaining";
import Targets from "../../components/targets/Targets";
import { ResponsiveContainer } from "recharts";
import Sales from "../../components/sales/Sales";
import SalesByCategory from "../../components/salesByCategory/SalesByCategory";
function Home() {
  const { t } = useTranslation();
  const classes = useStyles();
  const data = [
    {
      name: "Jan",
      fb: 2.5,
    },
    {
      name: "Feb",
      fb: 1.4,
    },
    {
      name: "Mar",
      fb: 6,
    },
    {
      name: "Avr",
      fb: 4,
    },
    {
      name: "Jan",
      fb: 4,
    },
    {
      name: "July",
      fb: 4,
    },
  ];
  const targets = [
    { name: t("sales"), nameKey: "views", value: 80 },
    { name: t("users"), nameKey: "contacts", value: 25 },
    { name: t("theProfits"), nameKey: "theProfits", value: 50 },
  ];

  return (
  <div className={classes.home}>
     
      <Box className={classes.box}>
        <CardsNumber />
      </Box>
      <Box className={classes.box}>
        <Sales />
      </Box>
      <Box className={classes.box}>
        <SalesByCategory />
      </Box>
      <Box className={classes.box}>
        <Targets title={t("monthTargets")} data={targets} />
      </Box>
      <Box className={classes.box}>
        <AreaChartView title={t("orders")} messages={"600"} data={data} />
      </Box>

      <Box className={classes.box}>
        <AreaChartView title={t("users")} messages={"200"} data={data} />
      </Box>
    </div>
  );
}

export default Home;
